const styles = (theme) => ({
    wrap: {
        display: 'flex',
        flexDirection: 'column',
    },
    button: {
        alignSelf: 'flex-end',
        marginBottom: '20px'
    },
    textField: {
        width: '45%'
    },
    discount: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    discountlabel: {
        width: '100%'
    }
});

export default styles;
